import React from 'react';
import PropTypes from 'prop-types';

const FormFileInput = ({ fileRef, name, onChange }) => (
  <input
    type="file"
    name={name}
    id={name}
    accept="image/gif, image/jpeg, image/png, application/pdf"
    className="inputfile inputfile-1"
    ref={fileRef}
    style={{ display: 'none' }}
    onChange={onChange}
  />
);

FormFileInput.propTypes = {
  fileRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default FormFileInput;
